import React, { Component } from 'react'

import firebase from '../firebase.js'

import './InfoPanelControl.css'

export class InfoPanelControl extends Component {
    constructor() {
        super()
        this.state = {}
    }

    componentDidMount() {
        let params = new URLSearchParams(window.location.search)
        this.controlId = params.get('id')

        this.advanceTimer = null
        this.updateTimer = null
        this.nextEvent = null
        this.pauseTime = null
        this.itemsRef = firebase
            .database()
            .ref(`InfoPanelControls/${this.controlId}/`)

        this.itemsRef.on('value', snapshot => {
            let item = snapshot.val()
            if (!item.pause && this.advanceTimer === null) {
                const nextTimeout = this.pauseTime
                    ? this.pauseTime
                    : item.timePerSlide
                this.advanceTimer = setTimeout(
                    this.scheduleSlide.bind(this),
                    nextTimeout
                )
                this.nextEvent = Date.now() + nextTimeout

                this.countdown()
            } else if (
                item.pause &&
                (this.advanceTimer !== null || this.updateTimer !== null)
            ) {
                this.pauseTime = this.state.untilNext
                console.log('pause time: ', this.pauseTime)
                if (this.advanceTimer) clearTimeout(this.advanceTimer)
                if (this.updateTimer) clearTimeout(this.updateTimer)
                this.advanceTimer = null
                this.updateTimer = null
            }

            this.setState({
                control: item,
            })
        })
    }

    componentWillUnmount() {
        this.itemsRef.off('value')
    }

    scheduleSlide() {
        console.log('schedule')
        this.nextSlide()
        this.advanceTimer = setTimeout(
            this.scheduleSlide.bind(this),
            this.state.control.timePerSlide
        )
        this.nextEvent = Date.now() + this.state.control.timePerSlide
    }

    countdown() {
        console.log(this.state.untilNext)
        this.updateTimer = setTimeout(() => {
            this.setState({
                untilNext: this.nextEvent - Date.now(),
            })
            this.countdown()
        }, 500)
    }

    nextSlide() {
        const control = this.state.control
        control.currentSlide = Math.min(
            control.currentSlide + 1,
            control.maxSlides
        )
        this.itemsRef.update(control)
    }

    previousSlide() {
        const control = this.state.control
        control.currentSlide = Math.max(
            control.minSlides,
            control.currentSlide - 1
        )
        this.itemsRef.update(control)
    }

    playToggle() {
        const control = this.state.control
        control.pause = !control.pause
        this.itemsRef.update(control)
    }

    slider() {
        const control = this.state.control
        return (
            <input
                className="slider"
                type="range"
                min={control.minSlides}
                max={control.maxSlides}
                value={control.currentSlide}
                onChange={evt => {
                    this.itemsRef.update({
                        currentSlide: parseInt(evt.target.value),
                    })
                }}
            />
        )
    }

    buttons() {
        const control = this.state.control
        if (!control) return <div>No control found</div>
        return (
            <div className="control-panel">
                <div className="header">
                    InfoPanel Slide Control {this.controlId}
                </div>
                <div className="current-slide">
                    Current Slide: {control.currentSlide}
                </div>
                <button
                    className="previous-slide"
                    onClick={this.previousSlide.bind(this)}>
                    previous
                </button>
                <div className="min-slide">{control.minSlides}</div>
                {this.slider()}
                <div className="max-slide">{control.maxSlides}</div>
                <button
                    className="next-slide"
                    onClick={this.nextSlide.bind(this)}>
                    next
                </button>
                <button className="play" onClick={this.playToggle.bind(this)}>
                    {control.pause ? 'play' : 'pause'}
                </button>
                <div className="time-per-slide">
                    seconds per slide: {Math.round(control.timePerSlide / 1000)}
                </div>

                <div className="countdown">
                    next slide:{' '}
                    {this.state.untilNext !== undefined
                        ? Math.round(this.state.untilNext / 1000)
                        : Math.round(control.timePerSlide / 1000)}{' '}
                    seconds
                </div>
            </div>
        )
    }

    render() {
        console.log('infoPanel control', {
            state: this.state,
            props: this.props,
        })

        let content = <div className="content" />
        let control = this.state.control

        return (
            <div>
                <div>{this.props.errorMessage}</div>
                {this.buttons()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/InfoPanelControl.js